'use strict';

exports.__esModule = true;

var _propDetect = require('prop-detect');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handlebar contructor
 *
 * @param {Element} scrollable
 * @contructor
 * @api public
 */

var handlebar = function () {
  function handlebar(scrollable, className) {
    _classCallCheck(this, handlebar);

    var el = this.el = document.createElement('div');
    el.className = className || 'iscroll-handlebar';
    scrollable.appendChild(el);
  }

  /**
   * Show the handlebar and resize it
   *
   * @param {Number} h
   * @api public
   */


  handlebar.prototype.resize = function resize(h) {
    var s = this.el.style;
    s.height = h + 'px';
    s.backgroundColor = 'rgba(0,0,0,0.4)';
  };

  /**
   * Hide this handlebar
   *
   * @api public
   */


  handlebar.prototype.hide = function hide() {
    this.el.style.backgroundColor = 'transparent';
  };

  /**
   * Move handlebar by translateY
   *
   * @param {Number} y
   * @api public
   */


  handlebar.prototype.translateY = function translateY(y) {
    var s = this.el.style;
    if (!_propDetect.transform) {
      s.top = y + 'px';
    } else {
      if (_propDetect.has3d) {
        s[_propDetect.transform] = 'translate3d(0, ' + y + 'px, 0)';
      } else {
        s[_propDetect.transform] = 'translateY(' + y + 'px)';
      }
    }
  };

  return handlebar;
}();

exports['default'] = handlebar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/iscroll-component/dest/handlebar.js
 ** module id = 37
 ** module chunks = 0
 **/